import type { SharedValue } from "react-native-reanimated";
import { useAnimatedStyle } from "react-native-reanimated";
import { StyleSheet } from "react-native-unistyles";

// eslint-disable-next-line stylesheet-tokens/no-raw-values -- not a theme value yet
export const DOT_RESET_PHASE = 3;

const stylesheet = StyleSheet.create(({ colors, font, spacing }) => ({
  container: {
    flexDirection: "row",
    alignItems: "center",
    pointerEvents: "none",
  },
  label: {
    fontFamily: font.families.body,
    fontSize: font.sizes.body,
    color: colors.foregroundDefaultMuted,
  },
  dots: {
    flexDirection: "row",
    alignItems: "flex-end",
    marginLeft: spacing(0.5),
    height: font.sizes.body,
  },
  dot: {
    fontFamily: font.families.body,
    fontSize: font.sizes.body,
    color: colors.foregroundDefaultMuted,
    lineHeight: font.sizes.body,
  },
}));

export const useListeningDotAnimatedStyle = ({
  index,
  activeDot,
}: {
  index: number;
  activeDot: SharedValue<number>;
}) =>
  useAnimatedStyle(() => {
    const phase = Math.round(activeDot.value);

    if (phase === DOT_RESET_PHASE) {
      return { opacity: 0.25 };
    }

    return { opacity: index <= phase ? 1 : 0.25 };
  });

export const useListeningIndicatorAnimatedStyles = ({
  level,
}: {
  level: SharedValue<number>;
}) => {
  const containerStyle = useAnimatedStyle(() => ({
    transform: [{ scale: 1 + level.value * 0.06 }],
  }));

  return { containerStyle };
};

export default stylesheet;
